<div class="container-fluid text-center logo-container">

  <img style="width: 110px;" src="../assets/images/oa-logo-orange_lg.png" alt="Outdoor Access" />

</div>


@if (!isSubmitted) {
  <div id="collect-email-title" class="title text-center card-title">{{ title }}</div>
}

@if (!isSubmitted) {
  <div id="collect-email-input-panel" class="container-fluid text-center">
    <div class="row">
      <div class="col-12">
        <!-- <span class="form-field-label oa-form-label">Email</span> -->
        <div>
          <input class="m-2" type="email " placeholder="Email Address" [(ngModel)]="email" email required />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- <span class="form-field-label oa-form-label">Zip Code</span> -->
        <div>
          <input class="m-2" autocomplete="postal-code zip" type="text" placeholder="Zip Code" maxlength="5" size="8" [(ngModel)]="zipCode" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-1 mb-3">
        <!-- <span class="form-field-label oa-form-label">Zip Code</span> -->
        <div>
          <p>Which states are you interested in? Click a state to select it.</p>
          <us-map (stateSelected)="onStateMapClicked($event)" [offeringType]="offeringType"></us-map>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary btn-block btn-lg-round mt-2" (click)="onContinueClick($event)" [disabled]="!canSubmit">
          {{ buttonText }}
          @if (submitting) {
            <i class="fa fa-circle-notch fa-spin"></i>
          }
        </button>
      </div>
    </div>
  </div>
}

@if (isSubmitted) {
  <div id="collect-email-success-panel" class="container-fluid text-center" (click)="onSuccessPanelClick($event)">
    <div class="row">
      <div class="col-12">
        <div class="title text-center card-title">Excellent!</div>
        <div class="title text-center card-title">
          {{responseText}}
        </div>
      </div>
    </div>
  </div>
}
